/* Luteria Fagundes — área de loja: filtros/ordenação da coleção, carrinho (página e gaveta), busca, índice das páginas */
(function () {
  'use strict';
  if (window.__lfShop) return;
  window.__lfShop = true;
  var LF = window.LF = window.LF || {};
  var raiz = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };

  /* =========================================================
     COLEÇÃO: filtros nativos + ordenação sem recarregar a página
     ========================================================= */
  function urlDoForm(root, form) {
    var params = new URLSearchParams();
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (v, k) { if (k !== 'lfs_price' && v !== '') params.append(k, v); });
      var preco = form.querySelector('input[name="lfs_price"]:checked');
      if (preco && preco.value && preco.value !== ':') {
        var p = preco.value.split(':');
        if (p[0] !== '') params.set(preco.getAttribute('data-gte'), p[0]);
        if (p[1] !== '') params.set(preco.getAttribute('data-lte'), p[1]);
      }
    }
    var sort = root.querySelector('[data-lfs-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    var q = params.toString();
    return (root.getAttribute('data-url') || location.pathname) + (q ? '?' + q : '');
  }

  function carregarColecao(root, url, opts) {
    opts = opts || {};
    var id = root.getAttribute('data-section');
    if (root.__ctrl) root.__ctrl.abort();
    var ctrl = root.__ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add('is-loading');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(id), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        var novo = doc.querySelector('[data-lfs-col]');
        if (!novo) { location.href = url; return; }
        root.querySelectorAll('[data-lfs-swap]').forEach(function (el) {
          var k = el.getAttribute('data-lfs-swap');
          var n = novo.querySelector('[data-lfs-swap="' + k + '"]');
          if (n) el.innerHTML = n.innerHTML;
        });
        // selects de ordenação fora da área trocada (barra do celular)
        var sNovo = novo.querySelectorAll('[data-lfs-sort]'), sVelho = root.querySelectorAll('[data-lfs-sort]');
        sVelho.forEach(function (s, i) { if (sNovo[i]) s.innerHTML = sNovo[i].innerHTML; });
        if (!novo.querySelector('[data-lfs-swap="botao"]')) {
          var b = root.querySelector('[data-lfs-swap="botao"]'); if (b) b.textContent = b.textContent.replace(/ · \d+$/, '');
        }
        history.replaceState(history.state, '', url);
        root.classList.remove('is-loading');
        if (opts.rolar) {
          var alvo = root.querySelector('.lfs-col__main');
          if (alvo) window.scrollTo({ top: alvo.getBoundingClientRect().top + window.scrollY - 24, behavior: 'smooth' });
        }
        document.dispatchEvent(new CustomEvent('lf:collection-updated', { detail: { url: url } }));
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; root.classList.remove('is-loading'); location.href = url; });
  }

  document.addEventListener('change', function (e) {
    var root = e.target.closest('[data-lfs-col]');
    if (!root) return;
    var form = e.target.closest('[data-lfs-filters]');
    if (form) { carregarColecao(root, urlDoForm(root, form)); return; }
    if (e.target.matches('[data-lfs-sort]')) {
      root.querySelectorAll('[data-lfs-sort]').forEach(function (s) { if (s !== e.target) s.value = e.target.value; });
      var f = root.querySelector('.lfs-col__aside [data-lfs-filters]') || root.querySelector('[data-lfs-filters]');
      carregarColecao(root, urlDoForm(root, f));
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-lfs-filters]');
    if (!form) return;
    e.preventDefault();
    var root = form.closest('[data-lfs-col]');
    if (root) carregarColecao(root, urlDoForm(root, form));
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lfs-col] a[data-lfs-clear], [data-lfs-col] a[data-lfs-page]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    carregarColecao(a.closest('[data-lfs-col]'), a.getAttribute('href'), { rolar: a.hasAttribute('data-lfs-page') });
  });

  /* =========================================================
     CARRINHO: gaveta + página (remover / quantidade via /cart/change.js)
     ========================================================= */
  var DRAWER_SEC = 'lf-cart-drawer-content';
  function gaveta() { return document.getElementById('LfCart'); }
  function naPaginaCarrinho() { return !!document.querySelector('[data-lfs-cart]') || /\/cart\/?$/.test(location.pathname); }

  function aplicarSecoes(secoes) {
    if (!secoes) return;
    var g = gaveta();
    if (g && secoes[DRAWER_SEC]) {
      var n = parse(secoes[DRAWER_SEC]).querySelector('[data-lfs-cd-inner]');
      var v = g.querySelector('[data-lfs-cd-inner]');
      if (n && v) v.replaceWith(n);
    }
    document.querySelectorAll('[data-lfs-cart]').forEach(function (sec) {
      var html = secoes[sec.getAttribute('data-section')];
      if (!html) return;
      var n2 = parse(html).querySelector('[data-lfs-cart-inner]');
      var v2 = sec.querySelector('[data-lfs-cart-inner]');
      if (n2 && v2) v2.replaceWith(n2);
    });
  }
  function secoesPedidas() {
    var ids = [];
    if (gaveta()) ids.push(DRAWER_SEC);
    document.querySelectorAll('[data-lfs-cart]').forEach(function (s) { ids.push(s.getAttribute('data-section')); });
    return ids.slice(0, 5);
  }

  /* Atualiza o conteúdo da gaveta (e da página do carrinho) com o estado atual */
  LF.refreshCartDrawer = function () {
    var ids = secoesPedidas();
    if (!ids.length) return Promise.resolve();
    return fetch(raiz() + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (s) {
        aplicarSecoes(s);
        var inner = document.querySelector('#LfCart [data-lfs-cd-inner]');
        if (inner && LF.setCartCount) LF.setCartCount(Number(inner.getAttribute('data-count')) || 0);
      }).catch(function () {});
  };
  LF.openCart = function () {
    if (!gaveta()) { location.href = raiz() + 'cart'; return; }
    LF.openDrawer('LfCart');
    LF.refreshCartDrawer();
  };

  function mudarLinha(li, qtd) {
    var escopo = li.closest('[data-lfs-cd], [data-lfs-cart]');
    if (escopo) escopo.classList.add('is-loading');
    li.classList.add('is-busy');
    return fetch(raiz() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: li.getAttribute('data-key'), quantity: qtd, sections: secoesPedidas(), sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (escopo) escopo.classList.remove('is-loading');
        if (!res.ok || res.j.status) {
          li.classList.remove('is-busy');
          var err = li.querySelector('[data-lfs-err]');
          if (err) { err.textContent = res.j.description || res.j.message || 'Não foi possível atualizar o carrinho.'; err.hidden = false; }
          return;
        }
        // Na página do carrinho com a Yampi ativa, o botão de finalizar foi clonado por ela: recarrega para ela refazer.
        if (li.closest('[data-lfs-cart]') && document.querySelector('.ymp-CrtpageMainFrm, .ymp_elem_mainBtn')) { location.reload(); return; }
        aplicarSecoes(res.j.sections);
        if (LF.setCartCount) LF.setCartCount(res.j.item_count);
        document.dispatchEvent(new CustomEvent('lf:cart-updated', { detail: Object.assign({ lfShop: true }, res.j) }));
      })
      .catch(function () { location.href = raiz() + 'cart'; });
  }

  document.addEventListener('click', function (e) {
    // Ícone da sacola: abre a gaveta (exceto na própria página do carrinho)
    var abre = e.target.closest('[data-lf-cart-open]');
    if (abre && gaveta() && !naPaginaCarrinho() && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      LF.openCart();
      return;
    }
    var rem = e.target.closest('[data-lfs-remove]');
    if (rem) {
      var li = rem.closest('[data-key]');
      if (!li) return;
      e.preventDefault();
      mudarLinha(li, 0);
      return;
    }
    var q = e.target.closest('[data-lfs-qty]');
    if (q) {
      var li2 = q.closest('[data-key]');
      if (!li2) return;
      e.preventDefault();
      mudarLinha(li2, Math.max(0, parseInt(q.getAttribute('data-lfs-qty'), 10) || 0));
    }
  });

  /* Observações do pedido (página do carrinho) */
  var tNota = null;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-lfs-note]')) return;
    clearTimeout(tNota);
    var v = e.target.value;
    tNota = setTimeout(function () {
      fetch(raiz() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }).catch(function () {});
    }, 500);
  });

  /* Outras partes do tema avisam que o carrinho mudou (ex.: produto adicionado) */
  document.addEventListener('lf:cart-updated', function (e) {
    if (e.detail && e.detail.lfShop) return;
    LF.refreshCartDrawer();
  });
  /* Ao voltar pelo histórico (cache do navegador), confere o carrinho */
  window.addEventListener('pageshow', function (e) { if (e.persisted) LF.refreshCartDrawer(); });

  /* =========================================================
     BUSCA: botão de limpar o campo
     ========================================================= */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-lfs-q]')) return;
    var b = e.target.form && e.target.form.querySelector('[data-lfs-q-clear]');
    if (b) b.hidden = !e.target.value;
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lfs-q-clear]');
    if (!b) return;
    e.preventDefault();
    var i = b.form && b.form.querySelector('[data-lfs-q]');
    if (i) { i.value = ''; i.focus(); }
    b.hidden = true;
  });

  /* =========================================================
     PÁGINAS DE TEXTO: destaca no índice a seção visível
     ========================================================= */
  function indices(scope) {
    (scope || document).querySelectorAll('[data-lfs-toc]').forEach(function (toc) {
      if (toc.__ok || !('IntersectionObserver' in window)) return;
      toc.__ok = true;
      var links = toc.querySelectorAll('a[href^="#"]');
      var mapa = {};
      links.forEach(function (a) { mapa[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (a) { a.classList.remove('is-active'); });
          var a = mapa[en.target.id]; if (a) a.classList.add('is-active');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      Object.keys(mapa).forEach(function (id) { var s = document.getElementById(id); if (s) io.observe(s); });
    });
  }

  /* =========================================================
     CONTA: alterna entre entrar e recuperar senha
     ========================================================= */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lfs-toggle]');
    if (!t) return;
    var alvo = document.getElementById(t.getAttribute('data-lfs-toggle'));
    if (!alvo) return;
    e.preventDefault();
    var aberto = alvo.classList.contains('is-open') || (location.hash === '#' + alvo.id && !alvo.classList.contains('is-closed'));
    var abrir = !aberto;
    alvo.classList.toggle('is-open', abrir);
    alvo.classList.toggle('is-closed', !abrir);
    if (history.replaceState) history.replaceState(history.state, '', location.pathname + location.search + (abrir ? '#' + alvo.id : ''));
    if (abrir) { var f = alvo.querySelector('input:not([type=hidden])'); if (f) f.focus(); }
    else { var l = document.querySelector('.lfs-acc__login input:not([type=hidden])'); if (l) l.focus(); }
  });
  /* Endereços: mostra o campo de estado conforme o país */
  function provincias(scope) {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) return;
    (scope || document).querySelectorAll('[data-lfs-country]').forEach(function (sel) {
      if (sel.__ok) return; sel.__ok = true;
      new Shopify.CountryProvinceSelector(sel.id, sel.getAttribute('data-lfs-country'), { hideElement: sel.getAttribute('data-lfs-province-wrap') });
    });
  }

  /* Rótulos curtos da ordenação no celular (ex.: "A a Z") */
  function curtos(scope) {
    (scope || document).querySelectorAll('select[data-curto] option[data-curto]').forEach(function (o) { o.textContent = o.getAttribute('data-curto'); });
  }
  document.addEventListener('lf:collection-updated', function () { curtos(); });

  function iniciar(scope) { indices(scope); provincias(scope); curtos(scope); }
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  window.addEventListener('load', function () { provincias(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
